/**
 * Created by Ning Jiang on 2/7/2019.
 */

import {BetLinesView} from "@nolimitcity/slot-game/bin/core/betline/BetLinesView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {StillImageBackground} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {NearWinReelDivider} from "@nolimitcity/slot-game/bin/game/reeldivider/NearWinReelDivider";
import {WinterHoardFontConfig} from "./WinterHoardFontConfig";
import {WinterHoardGameAssets} from "./WinterHoardGameAssets";
import {WinterHoardGameConfig} from "./WinterHoardGameConfig";
import {WinterHoardSoundConfig} from "./WinterHoardSoundConfig";
import {WinterHoardServerDataParser} from "./server/WinterHoardServerDataParser";
import {WinterHoardReelSymbol} from "./symbols/WinterHoardReelSymbol";
import {WinterHoardReelSymbolStateCreator} from "./symbols/WinterHoardReelSymbolStateCreator";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinterHoardLayerConfig} from "./config/WinterHoardLayerConfig";
import {WinterHoardFreeSpinOutroView} from "./freespin/transitions/WinterHoardFreeSpinOutroView";
import {WinterHoardReelBackground} from "./reelArea/WinterHoardReelBackground";
import {WinterHoardFreespinCounterView} from "./freespin/WinterHoardFreespinCounterView";
import {WinterHoardWildOverlayView} from "./freespin/WinterHoardWildOverlayView";
import {WinterHoardTransitionController} from "./freespin/transitions/WinterHoardTransitionController";
import {WinterHoardParsedGameData, WinterHoardParsedInitData} from "./server/data/IWinterHoardServerData";
import {WinterHoardLogoView} from "./logo/WinterHoardLogoView";
import {WinterHoardFreeSpinOverlayPresentation} from "./freespin/WinterHoardFreeSpinOverlayPresentation";
import {InitialWin} from "./gameround/InitialWin";
import {CountUpView} from "./views/CountUpView";
import {BigWinStep} from "./gameround/bigWin/BigWinStep";
import {WinTextView} from "./views/WinTextView";
import {WinEnd} from "./gameround/WinEnd";
import {MysterySymbolRevealView} from "./views/MysterySymbolRevealView";
import {NormalWin} from "./gameround/NormalWin";
import {ReelStart} from "./gameround/ReelStart";
import {ReelStop} from "./gameround/ReelStop";
import {SpinStart} from "./gameround/SpinStart";
import {SpinStop} from "./gameround/SpinStop";
import {DevToolsDemoView} from "./display/DevToolsDemoView";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {BetLineWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";
import {FreespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinZeroBetController";
import {GameModeTransitionController} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionController";
import {GameRoundConfig} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import { Reels } from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {BuffaloReelAreaView} from "./reel/BuffaloReelView";
import {BuffaloTransitionViewWrapper} from "./freespin/transitions/BuffaloTransitionViewWrapper";
import {MysterySymbolReveal} from "./gameround/MysterySymbolReveal";
import {PickTransitionController} from "./freespin/transitions/PickTransitionController";
import {BuffaloFreespinMultiplierView} from "./freespin/BuffaloFreespinMultiplierView";
import {IndicatorBackgroundView} from "./freespin/IndicatorBackgroundView";
import {FreespinSymbolData} from "./gameround/symbols/FreespinSymbolData";
import {SymbolData} from "./freespin/SymbolData";
import {IdleNormal} from "./gameround/IdleNormal";
import {BuffaloZeroBet} from "./gameround/zeroBet/BuffaloZeroBet";
import {AnimatedWinlines} from "./betline/animatedwinlines/AnimatedWinlines";
import {BuffaloSpinReelController} from "./reel/BuffaloSpinReelController";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {FreespinEnergyCollector} from "./freespin/FreespinEnergyCollector";
import {BigWinView} from "./views/BigWinView";
import {FeatureRestore} from "./gameround/freespin/FeatureRestore";
import {NearWinView} from "./views/NearWinView";
import {WinterHoardReelSymbolScatter} from "./symbols/WinterHoardReelSymbolScatter";
import {WinterHoardReelSymbolWild} from "./symbols/WinterHoardReelSymbolWild";
import {SymbolAttention} from "./gameround/symbols/SymbolAttention";
import {SoundPlayer} from "./sound/SoundPlayer";
import {ExtraFreespinView} from "./freespin/ExtraFreespinView";
import {SymbolDataStopped} from "./freespin/SymbolDataStopped";
import {FreespinSymbolDataStopped} from "./gameround/symbols/FreespinSymbolDataStopped";
import {Speedster} from "./debug/Speedster";
    
import {BuffaloTimelineReelsController} from "./reel/BuffaloTimelineReelsController";
import {BufffaloSymbolWinTease} from "./gameround/freespin/BuffaloSymbolWinTease";
import {BuffaloNearWin} from "./gameround/nearwin/BuffaloNearWIn";
import {BuffaloPickPresentation} from "./gameround/freespin/BuffaloPickPresentation";
import {BuffaloPickEndPresentation} from "./gameround/freespin/BuffaloPickEndPresentation";
import {BuffaloPickFakeSpin} from "./gameround/freespin/BuffaloPickFakeSpin";
import {BuffaloFreeSpinIntroView} from "./freespin/transitions/BuffaloFreeSpinIntroView";
import {FeaturePrice} from "./server/FeaturePrice";
import {PostWin} from "./gameround/PostWin";

export class WinterHoardGameModuleConfig implements IGameModuleConfig {

    public static instance:WinterHoardGameModuleConfig = new WinterHoardGameModuleConfig();
    private static background:StillImageBackground;
    private static reelDivider:NearWinReelDivider;
    private static betLinesView:BetLinesView;

    public static reelBackground:WinterHoardReelBackground;
    public static freeSpinCounterView:WinterHoardFreespinCounterView;
    public static freeSpinMultiplierView:BuffaloFreespinMultiplierView;
    public static overlayView:WinterHoardWildOverlayView;
    public static logoView:WinterHoardLogoView;
    public static energyCollector:FreespinEnergyCollector;
    public static bigWinView:BigWinView;
    public static nearWinView:NearWinView;
    public static addFsView:ExtraFreespinView;
    public static featurePrice:FeaturePrice;


    GAME_CONFIG:IGameConfig = WinterHoardGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = WinterHoardSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = WinterHoardFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = WinterHoardGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => {
        return new WinterHoardServerDataParser();
    };
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => {
        return new WinterHoardParsedInitData(data, <WinterHoardServerDataParser>dataParser);
    };
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => {
        return new WinterHoardParsedGameData(data, <WinterHoardServerDataParser>dataParser);
    };

    REELS?:() => Reels = ()=>{
        return new BuffaloTimelineReelsController();
    };

    REEL_AREA_VIEW:() => ReelAreaView = () => {
        return new BuffaloReelAreaView();
    };

    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => {
        return new BuffaloSpinReelController(reelId);
    };


    REEL_PART_CREATOR:() => ReelPartCreator = () => {
        return new ReelPartCreator(
            (symName:string, reelId:number, state?:ISymbolStateConfig):WinterHoardReelSymbol => {
                if(symName.indexOf("S") > -1) {
                    return new WinterHoardReelSymbolScatter(symName, reelId, state);
                }
                if(symName.indexOf("W") > -1) {
                    return new WinterHoardReelSymbolWild(symName, reelId, state);
                }
                return new WinterHoardReelSymbol(symName, reelId, state);
            });
    };

    SYMBOL_STATE_CREATOR:() => ReelSymbolStateCreator = () => {
        return new WinterHoardReelSymbolStateCreator();
    };

    // SCREENS:(() => ScreenController)[] = [];

     ZERO_BETS:(() => ZeroBetController)[] = [
         () => {
             return new FreespinZeroBetController();
         }
     ];

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => {
        return new BetLineWinIndividualWPController({
            symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
                return 0;
            }
        });
    };

    GAME_MODE_TRANSITIONS?:(() => GameModeTransitionController)[] = [ // FREESPIN_PICK
        () => {
            return new WinterHoardTransitionController(
                GameMode.NORMAL,
                "FREESPIN_COMBINED",
                //,
                new BuffaloTransitionViewWrapper(false)
                //new WinterHoardFreeSpinIntroView(StageManager.getLayer(WinterHoardLayerConfig.INTRO.name))
            );
        },
        () => {
            return new WinterHoardTransitionController(
                GameMode.NORMAL,
                "FREESPIN_PICK",
                new BuffaloTransitionViewWrapper(true)
                //new WinterHoardFreeSpinIntroView(StageManager.getLayer(WinterHoardLayerConfig.INTRO.name))
            );
        },
        () => {
            return new PickTransitionController("FREESPIN_PICK", "FREESPIN_TRANSFORM");
        },
        () => {
            return new PickTransitionController("FREESPIN_PICK", "FREESPIN_MULTIPLIER");
        },
        () => {
            return new WinterHoardTransitionController(
                "FREESPIN_TRANSFORM",
                GameMode.NORMAL,
                new WinterHoardFreeSpinOutroView(StageManager.getLayer(WinterHoardLayerConfig.INTRO.name))
            );
        },
        () => {
            return new WinterHoardTransitionController(
                "FREESPIN_MULTIPLIER",
                GameMode.NORMAL,
                new WinterHoardFreeSpinOutroView(StageManager.getLayer(WinterHoardLayerConfig.INTRO.name))
            );
        },
        () => {
            return new WinterHoardTransitionController(
                "FREESPIN_COMBINED",
                GameMode.NORMAL,
                new WinterHoardFreeSpinOutroView(StageManager.getLayer(WinterHoardLayerConfig.INTRO.name))
            );
        }
    ];




    GAME_ROUND_CONFIG:() => GameRoundConfig = () => {
        return {
            NORMAL : {
                idle : [
                    new IdleNormal()
                ],
                idleLoop : [],
                starting : [
                    new SpinStart(),
                    new ReelStart(2, 0.05),
                    new ReelStart(1, 0),
                    new ReelStart(3, 0.05),
                    new ReelStart(0, 0),
                    new ReelStart(4, 0.05),
                ],
                stoppable : [
                    new ReelStop(0),
                    new ReelStop(1),
                    new ReelStop(2),

                    //new WinterHoardNearWi(3),
                    new BuffaloNearWin(3),
                    //new BuffaloBigWinNearWin(3),
                    new ReelStop(3),
                    //new WinterHoardNearWin(4),
                    new BuffaloNearWin(4),
                    //new BuffaloBigWinNearWin(4),
                    new ReelStop(4),
                    new SpinStop()
                ],
                skippable : [
                    [
                        new MysterySymbolReveal() // TODO: Obsolete/Remove? Probably totally offet reel container within the class
                    ],
                    [
                        new InitialWin(),
                        new NormalWin(GameConfig.instance.WIN_RATIOS.normalWin[3]),
                        new BigWinStep(WinterHoardGameConfig.instance.WIN_RATIOS.normalWin[0], WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[0])
                    ],
                    [
                        new BigWinStep(WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[0], WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[1], WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new SymbolAttention()
                    ],
                    [
                        new PostWin()
                    ],
                    [
                        new WinEnd()
                    ]
                ]

            },

            FREESPIN_COMBINED : {
                idle : [
                    new FeatureRestore(),
                    new BuffaloZeroBet()
                ],
                idleLoop : [],
                starting : [
                    new FreespinSymbolData(),
                    new SpinStart(),
                    new ReelStart(0, 0),
                    new ReelStart(1, 0),
                    new ReelStart(2, 0),
                    new ReelStart(3, 0),
                    new ReelStart(4, 0),
                ],
                stoppable : [
                    new FreespinSymbolDataStopped(),
                    new ReelStop(0),
                    new ReelStop(1),
                    new ReelStop(2),

                    new BufffaloSymbolWinTease(2),
                    new BuffaloNearWin(3),

                    new ReelStop(3),

                    new BufffaloSymbolWinTease(3),
                    new BuffaloNearWin(4),
                    new ReelStop(4),

                    //new BufffaloSymbolWinTease(4),

                    new SpinStop(),
                ],
                skippable : [
                    [
                        new WinterHoardFreeSpinOverlayPresentation(),
                        new InitialWin(),
                        new NormalWin(GameConfig.instance.WIN_RATIOS.normalWin[3])
                    ],
                    [
                        new BigWinStep(WinterHoardGameConfig.instance.WIN_RATIOS.normalWin[0], WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[0])
                    ],
                    [
                        new BigWinStep(WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[0], WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[1], WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new PostWin()
                    ],
                    [
                        new WinEnd(),
                    ]
                ]
            },
            FREESPIN_TRANSFORM : {
                idle : [
                    new FeatureRestore(),
                    new BuffaloZeroBet()
                ],
                    idleLoop : [],
                    starting : [
                    new FreespinSymbolData(),
                    new SpinStart(),
                    new ReelStart(0, 0),
                    new ReelStart(1, 0),
                    new ReelStart(2, 0),
                    new ReelStart(3, 0),
                    new ReelStart(4, 0),
                ],
                    stoppable : [
                        new FreespinSymbolDataStopped(),
                        new ReelStop(0),
                        new ReelStop(1),
                        new ReelStop(2),

                        new BufffaloSymbolWinTease(2),
                        new BuffaloNearWin(3),
                        new ReelStop(3),

                        new BufffaloSymbolWinTease(3),
                        new BuffaloNearWin(4),
                        new ReelStop(4),

                        //new BufffaloSymbolWinTease(4),

                        new SpinStop(),
                ],
                    skippable : [
                    [
                        new WinterHoardFreeSpinOverlayPresentation(),
                        new InitialWin(),
                        new NormalWin(GameConfig.instance.WIN_RATIOS.normalWin[3])
                    ],
                    [
                        new BigWinStep(WinterHoardGameConfig.instance.WIN_RATIOS.normalWin[0], WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[0])
                    ],
                    [
                        new BigWinStep(WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[0], WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[1], WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new PostWin()
                    ],
                    [
                        new WinEnd(),
                    ]
                ]
            },
            FREESPIN_MULTIPLIER : {
                idle : [
                    new FeatureRestore(),
                    new BuffaloZeroBet()
                ],
                idleLoop : [],
                starting : [
                    new FreespinSymbolData(),
                    new SpinStart(),
                    new ReelStart(0, 0),
                    new ReelStart(1, 0),
                    new ReelStart(2, 0),
                    new ReelStart(3, 0),
                    new ReelStart(4, 0),
                ],
                stoppable : [
                    new FreespinSymbolDataStopped(),
                    new ReelStop(0),
                    new ReelStop(1),
                    new ReelStop(2),
                    new BuffaloNearWin(3),
                    new ReelStop(3),
                    new BuffaloNearWin(4),
                    new ReelStop(4),
                    new SpinStop(),
                ],
                skippable : [
                    [
                        new WinterHoardFreeSpinOverlayPresentation(),
                        new InitialWin(),
                        new NormalWin(GameConfig.instance.WIN_RATIOS.normalWin[3])
                    ],
                    [
                        new BigWinStep(WinterHoardGameConfig.instance.WIN_RATIOS.normalWin[0], WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[0])
                    ],
                    [
                        new BigWinStep(WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[0], WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[1], WinterHoardGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new PostWin()
                    ],
                    [
                        new WinEnd(),
                    ]
                ]
            },
            FREESPIN_PICK : {
                idle : [new BuffaloPickPresentation()],
                idleLoop : [],
                starting : [new BuffaloPickFakeSpin(true)],
                stoppable : [new BuffaloPickFakeSpin(false)],
                skippable : [[new BuffaloPickEndPresentation()]]
            }
    }


    };



    GAME_FEATURE_CREATOR:() => void = () => {
        new Speedster();
        const soundPlayer:SoundPlayer = new SoundPlayer();
        WinterHoardGameModuleConfig.countUpView = new CountUpView();
        WinterHoardGameModuleConfig.reelBackground = new WinterHoardReelBackground();
        WinterHoardGameModuleConfig.freeSpinCounterView = new WinterHoardFreespinCounterView();
        WinterHoardGameModuleConfig.bigWinView = new BigWinView();
        WinterHoardGameModuleConfig.nearWinView = new NearWinView();

        WinterHoardGameModuleConfig.freeSpinMultiplierView = new BuffaloFreespinMultiplierView();

        WinterHoardGameModuleConfig.freeSpinIntroView = new BuffaloFreeSpinIntroView();

        WinterHoardGameModuleConfig.overlayView = new WinterHoardWildOverlayView();
        WinterHoardGameModuleConfig.logoView = new WinterHoardLogoView();
        WinterHoardGameModuleConfig.winTextView = new WinTextView();
        WinterHoardGameModuleConfig.mysterySymbolRevealView = new MysterySymbolRevealView();
        WinterHoardGameModuleConfig.indicatorBackground = new IndicatorBackgroundView();
        WinterHoardGameModuleConfig.energyCollector = new FreespinEnergyCollector();
        WinterHoardGameModuleConfig.addFsView = new ExtraFreespinView();

        WinterHoardGameModuleConfig.devToolsDemoView = new DevToolsDemoView();

        /*WinterHoardGameModuleConfig.background = new StillImageBackground({
            layer : WinterHoardGameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {image : WinterHoardGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                FREESPIN : {image : WinterHoardGameAssets.FREE_SPIN_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                FREESPIN_PICK : {image : WinterHoardGameAssets.FREE_SPIN_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                FREESPIN_TRANSFORM : {image : WinterHoardGameAssets.FREE_SPIN_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                FREESPIN_MULTIPLIER : {image : WinterHoardGameAssets.FREE_SPIN_BACKGROUND, offset : new PIXI.Point(-480, -480)}
            },
            stretch : false
        });*/

        WinterHoardGameModuleConfig.symbolData = new SymbolData();
        WinterHoardGameModuleConfig.symbolDataStopped = new SymbolDataStopped();
        WinterHoardGameModuleConfig.animatedWinLines = new AnimatedWinlines();
        WinterHoardGameModuleConfig.featurePrice = new FeaturePrice();
    };
    public static countUpView:CountUpView;
    public static winTextView:WinTextView;
    public static mysterySymbolRevealView:MysterySymbolRevealView;
    public static indicatorBackground:IndicatorBackgroundView;
    public static devToolsDemoView:DevToolsDemoView;
    public static symbolData:SymbolData;
    public static symbolDataStopped:SymbolDataStopped;
    public static animatedWinLines:AnimatedWinlines;
    public static freeSpinIntroView:BuffaloFreeSpinIntroView;


    constructor() {
        if(WinterHoardGameModuleConfig.instance) {
            throw new Error("WinterHoardGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}